module.exports = __webpack_public_path__ + "media/images/solutions-analytics-primary-ed52b00fb12d6c35100fd58a62d1c4f4.svg";